import {Component, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewInit, OnDestroy} from '@angular/core';
import {
  CampaignInfluencerStatus, ChannelStatus, CommonConstant, FacebookAuthPreviousState,
  platformIconPath
} from '../../../app.constants';
import {InfluencerService} from '../../../services/influencer/influencer.service';
import {AppSettings} from '../../../utils/app-settings';
import { AchooPopupComponent } from '../../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../../services/modal/modal.service';
import { TranslateService } from '@ngx-translate/core';
import {UserService} from '../../../services/user.service';
import {Channel} from '../../../../models/common';
import {AuthService} from '../../../core/auth.service';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {CampaignService} from '../../../services/campaign/campaign.service';
import {saveAs as saveAs} from 'file-saver';

@Component({
  selector: 'campaign-details',
  templateUrl: './campaign-details.component.html',
  styleUrls: ['./campaign-details.component.scss']
})
export class CampaignDetailsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('AcceptCampaignPopup')
  AcceptCampaignPopup: AchooPopupComponent;
  @Input() campaign: any;
  @Input() isLandingPageMode: boolean;
  @Input() isDeletedOrError = false;
  @Output() openContactEvt: EventEmitter<any> = new EventEmitter();
  @Output() declineCallback: EventEmitter<any> = new EventEmitter();
  @Output() acceptInvitation: EventEmitter<any> = new EventEmitter();
  showDeclineModal = false;

  public listExistingChannel: Channel[] = [];
  public isConfirmingInfluencerNameAndEmail: boolean;
  private isFbAuthFail = false;
  private confirmInfluencerNameAndEmailSubscription: Subscription;
  constructor(private influencerService: InfluencerService,
              private campaignService: CampaignService,
              private modalService: ModalService,
              private userService: UserService,
              private auth: AuthService,
              private activatedRoute: ActivatedRoute,
              private translate: TranslateService) {}

  ngOnInit() {
    const currentInfluencer = this.userService.getInfluencerInfo();
    if (currentInfluencer) {
      this.loadInfluencerChannels(currentInfluencer.id);
    }
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.error) {
        this.isFbAuthFail = true;
      }
    });
  }

  ngAfterViewInit() {
    const localChannelAuthData = this.auth.getInfluencerChannelAuthorizationLocalData();
    if (localChannelAuthData) {
      this.modalService.openInCenter(this.AcceptCampaignPopup, null, 'campaign-confirm-popup');
      // remove the local auth data
      this.auth.removeInfluencerChannelAuthorizationLocalData();
    }
    this.confirmInfluencerNameAndEmailSubscription = this.influencerService.confirmInfluencerNameAndEmailObserver
      .subscribe(res => {
        this.isConfirmingInfluencerNameAndEmail = res;
      });
  }

  ngOnDestroy() {
    if (this.confirmInfluencerNameAndEmailSubscription) {
      this.confirmInfluencerNameAndEmailSubscription.unsubscribe();
    }
  }

  private loadInfluencerChannels(influencerId) {
    this.influencerService.getInfluencerChannels(influencerId).subscribe((res) => {
      this.listExistingChannel = res;
      const igChannels = this.listExistingChannel.filter(ec => ec.platform.id === platformIconPath.instagram.id);
      if (igChannels.length > 0) {
        const channelAuthData = this.auth.getInfluencerChannelAuthorizationLocalData();
        igChannels.forEach(cn => {
          if (channelAuthData && cn.id === channelAuthData.activeChannelId && this.isFbAuthFail) {
            cn.type = ChannelStatus.AUTHORIZE_FAILED;
          } else if (!this.auth.hasAuthorizedIgChannel(cn.id)) {
            // force to influencer always to authorize the ig channel before accepting to get the updated auth token
            cn.type = ChannelStatus.UNAUTHORIZE;
          }
        });
      }
    });
  }

  isPdfFile(contentType) {
    return contentType === 'application/pdf';
  }

  isShowButton() {
    return AppSettings.isActiveNewCampaignFlow() && this.isLandingPageMode && this.campaign && !this.isDeletedOrError;
  }

  onDecline() {
    this.showDeclineModal = true;
  }

  acceptToDecline(evt) {
    this.showDeclineModal = false;
    this.declineCallback.emit();
    this.campaign.status = CampaignInfluencerStatus.DELETE;
  }

  openContact() {
    this.openContactEvt.emit();
  }

  closeDeclineModal() {
    this.showDeclineModal = false;
  }

  clickOutsideDeclineModal(evt) {
    if (!evt.target.classList.contains('decline-btn')) {
      this.closeDeclineModal();
    }
  }

  onAcceptCampaign() {
    const hasConfirmedAllChannels = this.listExistingChannel.length > 0
    && this.listExistingChannel.filter(cn => cn.type !== ChannelStatus.AUTHORIZED).length === 0;
    // if already confirmed at least 1 channel, proceed without authorizing channels
    // otherwise, show the popup to require the influencer authorize their channels.
    if (hasConfirmedAllChannels) {
      this.modalService.close();
      this.acceptInvitation.emit();
    } else {
      this.modalService.openInCenter(this.AcceptCampaignPopup, null, 'campaign-confirm-popup');
    }
  }

  onConfirmChannel() {
    this.modalService.close();
    this.acceptInvitation.emit();
  }

  get acceptButtonLabel() {
    if (!this.listExistingChannel) {
      return this.translate.instant('common.btn.continue');
    }
    if (this.listExistingChannel.length === 0
      || this.listExistingChannel.filter(cn => cn.type !== ChannelStatus.AUTHORIZED).length > 0) {
      return this.translate.instant('common.btn.continue');
    } else {
      return this.translate.instant('common.btn.accept');
    }
  }

  closeNotification() {
    this.modalService.close();
  }

  checkAuthorizationChannel(list: any) {
    let authorizedChannels = [];
    authorizedChannels = list.filter(item => item.platform.id !== platformIconPath.instagram.id && item.type === ChannelStatus.AUTHORIZED);
    const igChannels = list.filter(item => item.platform.id === platformIconPath.instagram.id);
    if (igChannels && igChannels.length > 0) {
      igChannels.map(cn => {
        this.influencerService.getInfluencerLoginStatus(cn.id).subscribe(res => {
          if (res.status === ChannelStatus.AUTHORIZED) {
            authorizedChannels.push(cn);
          } else {
            return;
          }
        });
      });
    }
    return authorizedChannels;
  }

  get activePageBeforeAuthorizingFb() {
    return FacebookAuthPreviousState.ON_CAMPAIGN_INVITATION;
  }

  downloadFile(fileData) {
    const campaignFileData = Object.assign({}, fileData, {
      content: fileData.image
    });
    this.campaignService.downloadCampaignMaterials(campaignFileData).subscribe(data => {
      if (!data) {
        return;
      } else {
        saveAs(data, fileData.name);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/main/campaign-new/campaign-details/campaign-details.component.ts